export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_your_stripe_key';

export const API_ENDPOINTS = {
  // Auth
  login: '/auth/login',
  register: '/auth/register',
  me: '/auth/me',
  logout: '/auth/logout',

  // Subscription
  subscriptionTiers: '/subscription/tiers',
  subscriptionStatus: '/subscription/status',
  createCheckout: '/subscription/create-checkout-session',
  verifySession: '/subscription/verify-session',
  cancelSubscription: '/subscription/cancel',

  // Upload & Processing
  initBatch: '/upload/init-batch',
  uploadBatch: (batchId: string) => `/upload/batch/${batchId}`,
  batchStatus: (batchId: string) => `/upload/batch/${batchId}/status`,
  cancelBatch: (batchId: string) => `/upload/batch/${batchId}/cancel`,

  // Batch Management
  batchHistory: '/batch/history',
  batchDetails: (batchId: string) => `/batch/${batchId}`,
  downloadBatch: (batchId: string) => `/batch/${batchId}/download`,

  // Processing
  backgrounds: '/processing/backgrounds',
  uploadBackground: '/processing/backgrounds/upload',
  deleteBackground: (id: string) => `/processing/backgrounds/${id}`,
  presets: '/processing/presets',
  queueStatus: '/processing/queue/status',
};
